/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_tdigest.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an untyped histogram to a TDigest, assuming the values are centroids.
 *
 * @example
 * FROM histogram_standard_index
 *  | WHERE instance == "hand-rolled"
 *  | EVAL tdigest = to_tdigest(responseTime)
 *  | KEEP responseTime, tdigest
 * ;
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_tdigest',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'exponential_histogram',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'tdigest',
    },
    {
      params: [
        {
          name: 'field',
          type: 'histogram',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'tdigest',
    },
    {
      params: [
        {
          name: 'field',
          type: 'tdigest',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'tdigest',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
